// Local Constants

import * as libCon from './community-hats-js-library/Constants';
import { nowInStudyLocation } from './community-hats-js-library/utils/dateFunctions';

// Version
export const VERSION = '2026.11.05';

// Authentication
export const MAX_IDLE_MINUTES = 90;

export const DEBUG = process.env.REACT_APP_DEBUG === 'True';

// TIme Zone
export const FITBIT_TIME_ZONE = libCon.GENERAL_CONFIG.timezone;

// Pages
export const PAGE_MANAGER_START = '/';
export const PAGE_MANAGER_BY_PASS_PWA = '/non_pwa';
export const PAGE_SET_UP_BUNDLE = '/set_up_bundle';
export const PAGE_DEPLOY_BUNDLE = '/deploy_bundle';
export const PAGE_COLLECT_DATA = '/collect_data';
export const PAGE_COLLECT_DATA_VENDOR_SPOT = '/collect_data_vendor_spot';
export const PAGE_SYNC_BUNDLE = '/sync_bundle';
export const PAGE_BUNDLE_STATUS = '/bundle_status';
export const PAGE_BUNDLE_RETRIEVE = '/bundle_retrieve';
export const PAGE_MANAGE_BUNDLE = '/bundle_manage';
export const PAGE_RECURENT_SURVEYS = '/recurent_surveys';
export const PAGE_WOMENS_MENTAL_AND_HEALTH_SURVEYS = '/womens_and_mental_health_surveys';
export const PAGE_INTERMEDEATE_WOMENS_MENTAL_AND_HEALTH_SURVEYS = '/intermedeate_womens_and_mental_health_surveys';
export const PAGE_PARTICIPANT_INTAKE_FORM = '/participant_intake_form';
export const PAGE_HOUSE_INTAKE_FORM = '/house_intake_form';
export const PAGE_PARTICIPANT_REPORT = '/participant_report';
export const PAGE_PARTICIPANT_UNENROLL = '/participant_unenroll';
export const Page_RE_INSTALL_APPLICATIONS = '/re_install_applications';

export const PAGE_MANAGE_BUNDLE_REPLACE_WEARABLE = PAGE_MANAGE_BUNDLE + '/replace_wearable';
export const PAGE_MANAGE_BUNDLE_REMOVE_SENSOR = PAGE_MANAGE_BUNDLE + '/remove_sensor';
export const PAGE_MANAGE_BUNDLE_ADD_SENSOR = PAGE_MANAGE_BUNDLE + '/add_sensor';
export const PAGE_MANAGE_BUNDLE_CHANGE_HOUSE = PAGE_MANAGE_BUNDLE + '/change_house';
export const PAGE_MANAGE_BUNDLE_REPLACE_EMAIL = PAGE_MANAGE_BUNDLE + '/replace_email';
export const PAGE_MANAGE_BUNDLE_MOVE_SENSOR = '/move_sensor';

export const PAGE_TOOLS_MAIN = '/tools';
export const PAGE_TOOL_LOCATION_EXTRACTOR = PAGE_TOOLS_MAIN + '/location_extractor';
export const PAGE_TOOL_FITBIT_API_UPDATER = PAGE_TOOLS_MAIN + '/fitbit_api_updater';
export const PAGE_TOOL_GOOGLE_HEALTH_API_UPDATER = PAGE_TOOLS_MAIN + '/google_health_api_updater';
export const PAGE_TOOL_WEARABLE_SERIAL_CHECKER = PAGE_TOOLS_MAIN + '/wearable_serial_checker';
export const PAGE_TOOL_GOVEE_ACTIVATION_CODES = PAGE_TOOLS_MAIN + '/govee_actvation_codes';
export const PAGE_TOOL_CORRECT_PHONE_SERIAL = PAGE_TOOLS_MAIN + '/correct_phone_serial';

// Languages
export const BASE_LANGUAGES = 'BASE_LANGUAGES';
export const STORAGE_CURRENT_LOCAL = 'STORAGE_CURRENT_LOCAL';
export const UPDATING_LANGUAGE = 'UPDATING_LANGUAGE';
export const LANGUAGE_LOADING_TIME = 1000;

// Buttons
export const PRIMARY_BUTTON = 'primary';
export const PRIMARY_BUTTON_DISSABLED_BUTTON = 'primary_disabled';
export const DANGER_BUTTON = 'danger';
export const SAVE_EDIT_BUTTON = 'save_edit_button';
export const SAVE_EDIT_BUTTON_DISABLED = 'save_edit_button_disabled';
export const MODULE_REGULAR_BUTTON = 'module_regular_button';
export const MODULE_CANCEL_BUTTON = 'module_cancel_button';
export const LANGUAGE_BUTTON = 'language_button';
export const SELECTED_LANGUAGE_BUTTON = 'selected_language_button';
export const LIKERT_BUTTON = 'likert_button';
export const SELECTED_LIKERT_BUTTON = 'selected_likert_button';

// Spinner
export const BUTTON_SPINNER = 'button_spinner';
export const SMALL_SPINNER = 'small_spinner';

// Text
export const SECTION_TITLE_TEXT = 'section_title';
export const MODULE_TITLE_TEXT = 'module_title';
export const INSTRUCTIONS_TEXT = 'instructions_text';
export const INFO_TEXT = 'info_text';
export const ELEMENT_TITLE_TEXT = 'element_title_text';
export const ELEMENT_TEXT = 'element_text';
export const SUCCESS_TEXT = 'success_text';
export const DEFAULT_INFO_TEXT = 'default_info_text';
export const DANGER_TEXT = 'danger_text';
export const LONG_TEXT = 'long_text';
export const OPTION_TEXT = 'option_text';
export const DISABLED_OPTION_TEXT = 'disabled_option_text';

// Checkbox
export const MAIN_PROGRESS_CHECKBOX = 'main_checkbox';
export const SECONDARY_PROGRESS_CHECKBOX = 'secondary_checkbox';
export const DEFAULT_OPTION_CHECKBOX = 'default_option_checkbox';
export const MULTIPLE_CHOICE_ANSWER_CHECKBOX = 'multiple_choice_answer_checkbox';

// Suffix constants
export const LAST_SEARCHED_VALUE = '__LAST_SEARCHED__VALUE__';
export const EDITING_VALUE = '__EDITING_VALUE__';
export const OTHER_VALUE = '__OTHER_VALUE__';
export const INCLUDE_OTHER_VALUE = '__INCLUE_OTHER_VALUE__';
export const PREVIEW_VALUE = '__PREVIEW__';

// General Store Values
export const RAG_LAST_NAME = 'RAG_LAST_NAME';
export const RAG_FIRST_NAME = 'RAG_FIRST_NAME';
export const RAG_YEAR_OF_BIRTH = 'RAG_YEAR_OF_BIRTH';
export const RAG_HAS_COPIED = 'RAG_HAS_COPIED';
export const RAG_HAS_COPIED_EMAIL = 'RAG_HAS_COPIED_EMAIL';
export const RAG_HAS_COPIED_PASSWORD = 'RAG_HAS_COPIED_PASSWORD';
export const BATTERY_CHANGE_DATE = 'BATTERY_CHANGE_DATE';
export const BATTERY_CHANGE_TIME = 'BATTERY_CHANGE_TIME';

// Airtable Object Status
export const ATO_EMPTY = 'ATO_EMPTY';
export const ATO_ONLY_LOCAL = 'ATO_ONLY_LOCAL';
export const ATO_UP_TO_DATE = 'ATO_UP_TO_DATE';
export const ATO_NEEDS_SYNCH = 'ATO_NEEDS_SYNCH';

// Checkboxes
export const GA_SET_UP_GOOGLE_ACCOUNT = 'GA_SET_UP_GOOGLE_ACCOUNT';
export const GA_SET_UP_DROPBOX_ACCOUNT = 'GA_SET_UP_DROPBOX_ACCOUNT';
export const GA_DOWNLOAD_DROPBOX_APP = 'GA_DOWNLOAD_DROPBOX_APP';
export const GA_CREATE_DROPBOX_ACCOUNT = 'GA_CREATE_DROPBOX_ACCOUNT';
export const GA_ACTIVATE_ACCOUNT_EMAIL = 'GA_ACTIVATE_ACCOUNT_EMAIL';
export const GA_ADD_EMAIL_TO_DATABASE = 'GA_ADD_EMAIL_TO_DATABASE';
export const TA_SET_UP_TRACKER_APP = 'TA_SET_UP_TRACKER_APP';
export const TA_DOWNLOAD_TACKER_APP = 'TA_DOWNLOAD_TACKER_APP';
export const TA_TURN_ON_LOCATION = 'TA_TURN_ON_LOCATION';
export const TA_TURN_ON_BLUETOOTH = 'TA_TURN_ON_BLUETOOTH';
export const TA_GET_PHONE_SERIAL = 'TA_GET_PHONE_SERIAL';
export const TA_LOCATION_PERMISSIONS = 'TA_LOCATION_PERMISSIONS';
export const TA_ACTIVATE_TRACKING = 'TA_ACTIVATE_TRACKING';
export const FTB_DOWNLOAD_APPLICATION = 'FTB_DOWNLOAD_APPLICATION';
export const FTB_CREATE_NEW_ACCOUNT = 'FTB_CREATE_NEW_ACCOUNT';
export const FTB_SET_TIME_ZONE = 'FTB_SET_TIME_ZONE';
export const FTB_SET_UP_DEVICE = 'FTB_SET_UP_DEVICE';
export const FTB_SET_API = 'FTB_SET_API';
export const FTB_DEV_LOGIN = 'FTB_DEV_LOGIN';
export const FTB_GO_TO_ADD_APP = 'FTB_GO_TO_ADD_APP';
export const FTB_FILL_VALUES = 'FTB_FILL_VALUES';
export const FTB_COPY_CLIENT_ID = 'FTB_COPY_CLIENT_ID';
export const FTB_GO_TO_AUTHORIZATION_PAGE = 'FTB_GO_TO_AUTHORIZATION_PAGE';
export const FTB_COPY_TOKEN_AND_REQUEST = 'FTB_COPY_TOKEN_AND_REQUEST';
export const FTB_TEST_TOKEN = 'FTB_TEST_TOKEN';
export const GTO_SET_UP_GOOGLE_TAKE_OUT = 'GTO_SET_UP_GOOGLE_TAKE_OUT';
export const GTO_SCHEDULE_GOOGLE_TAKE_OUT = 'GTO_SCHEDULE_GOOGLE_TAKE_OUT';
export const GTO_GENERATE_DB_SHARE_LINK = 'GTO_GENERATE_DB_SHARE_LINK';
export const APT_ADD_PARTICIPANT_TO_DATABASE = 'APT_ADD_PARTICIPANT_TO_DATABASE';
export const APPD_PHONE_PLACEMENT = 'APPD_PHONE_PLACEMENT';
export const APPD_LINK_PHONE_SERIAL = 'APPD_LINK_PHONE_SERIAL';
export const APPD_ADD_PHONE_PLACEMENT = 'APPD_ADD_PHONE_PLACEMENT';
export const AWP_WEARABLE_PLACEMENT = 'AWP_WEARABLE_PLACEMENT';
export const AWP_ADD_WEARABLE_PLACEMENT = 'AWP_ADD_WEARABLE_PLACEMENT';
export const AWP_LINK_WEARABLE_SERIAL = 'AWP_LINK_WEARABLE_SERIAL';
export const AWP_GET_WEARABLE_SERIAL = 'AWP_GET_WEARABLE_SERIAL';
export const ELC_EXTRACT_LOCATIONS_COORDINATES = 'ELC_EXTRACT_LOCATIONS_COORDINATES';
export const ALD_ADD_LOCATION_TO_DATABASE = 'ALD_ADD_LOCATION_TO_DATABASE';
export const APAR_PARTICIPANT_PLACEMENT = 'APAR_PARTICIPANT_PLACEMENT';
export const IS_INSERT_SIM = 'IS_INSERT_SIM';
export const ED_EXPLAIN_DUTIES = 'ED_EAT_OBJECT_WEARABLEXPLAIN_DUTIES';
export const ED_EXPLAIN_FITBIT = 'ED_EXPLAIN_FITBIT';
export const GD_GIVE_DEVICES = 'GD_GIVE_DEVICES';
export const GD_DELETE_APP = 'GD_DELETE_APP';
export const GD_SHOW_PHONE_PIN = 'GD_SHOW_PHONE_PIN';
export const UHW_UPDATE_HEIGHT_AND_WEIGHT = 'UHW_UPDATE_HEIGHT_AND_WEIGHT';
export const LTA_RESTART_TRACKING_APP = 'LTA_RESTART_TRACKING_APP';
export const LTA_TURN_ON_LOCATION = 'LTA_TURN_ON_LOCATION';
export const LTA_TURN_ON_BLUETOOTH = 'LTA_TURN_ON_BLUETOOTH';
export const GAF_GROUP_APPS_IN_FOLDER = 'GAF_GROUP_APPS_IN_FOLDER';
export const TB_TAG_BUNDLE = 'TB_TAG_BUNDLE';
export const PIF_AMINISTER_INTAKE_FORM = 'PIF_AMINISTER_INTAKE_FORM';
export const HIF_AMINISTER_INTAKE_FORM = 'HIF_AMINISTER_INTAKE_FORM';
export const SUG_SET_UP_SENSOR = 'SUG_SET_UP_SENSOR';
export const SUG_DOWNLOAD_APP = 'SUG_DOWNLOAD_APP';
export const SUG_ADD_DEVICE_TO_APP = 'SUG_ADD_DEVICE_TO_APP';
export const SUG_CREATE_ACCOUNT = 'SUG_CREATE_ACCOUNT';
export const SUG_ADD_INBOX_SENSOR = 'SUG_ADD_INBOX_SENSOR';

export const SUK_SET_UP_SENSOR = 'SUK_SET_UP_SENSOR';
export const SUK_DOWNLOAD_APP = 'SUK_DOWNLOAD_APP';
export const SUK_ADD_DEVICE_TO_APP = 'SUK_ADD_DEVICE_TO_APP';
export const SUK_SET_LOG_INTERVAL = 'SUK_SET_LOG_INTERVAL';
export const SUK_DISABLE_AUTOCONNECT = 'SUK_DISABLE_AUTOCONNECT';

export const AS_SENSOR_BASE = 'AS_SENSOR_BASE';

export const getASCheckBoxId = (positionID) => AS_SENSOR_BASE + '__' + positionID;

export const BD_ADD_BUNDLE_TO_DATABASE = 'BD_ADD_BUNDLE_TO_DATABASE';

export const CC_COLLECT_DATA = 'CC_COLLECT_DATA';

export const SB_SYNC_BUNDLE = 'SB_SYNC_BUNDLE';

export const RB_COLLECT_DATA = 'RB_COLLECT_DATA';
export const RB_CHECK_BUNDLE = 'RB_CHECK_BUNDLE';

// Unenroll Participant
export const UP_COLLECT_DATA = 'UP_COLLECT_DATA';
export const UP_CHECK_BUNDLE = 'UP_CHECK_BUNDLE';
export const UP_DELETE_ALL_APPS = 'UP_DELETE_ALL_APPS';
export const UP_RETRIEVE_BUNDLE = 'UP_RETRIEVE_BUNDLE';
export const UP_GIVE_PHONE = 'UP_GIVE_PHONE';

// Replace Wearable
export const RW_COLLECT_DATA = 'RW_COLLECT_DATA';
export const RW_END_AND_REMOVE_WEARABLE_PLACEMENT = 'RW_END_AND_REMOVE_WEARABLE_PLACEMENT';
export const RW_REMOVE_CURRENT_FITBIT_DEVICE = 'RW_REMOVE_CURRENT_FITBIT_DEVICE';
export const RW_SET_UP_NEW_DEVICE = 'RW_SET_UP_NEW_DEVICE';
export const RW_GET_WEARABLE_SERIAL = 'RW_GET_WEARABLE_SERIAL';
export const RW_LINK_WEARABLE_SERIAL = 'RW_LINK_WEARABLE_SERIAL';
export const RW_WEARABLE_PLACEMENT = 'RW_WEARABLE_PLACEMENT';
export const RW_UPDATE_BUNDLE_TO_DATABASE = 'RW_UPDATE_BUNDLE_TO_DATABASE';

// Replace Email
export const RE_COLLECT_DATA = 'RE_COLLECT_DATA';
export const RE_END_AND_REMOVE_WEARABLE_PLACEMENT = 'RE_END_AND_REMOVE_WEARABLE_PLACEMENT';
export const RE_SET_UP_NEW_DEVICE = 'RE_SET_UP_NEW_DEVICE';
export const RE_WEARABLE_PLACEMENT = 'RE_WEARABLE_PLACEMENT';
export const RE_UPDATE_BUNDLE_TO_DATABASE = 'RE_UPDATE_BUNDLE_TO_DATABASE';
export const RE_REMOVE_EMAIL_FROM_DEVICE = 'RE_REMOVE_EMAIL_FROM_DEVICE';
export const RE_REMOVE_FITBIT_FROM_PAIRED_DEVICES = 'RE_REMOVE_FITBIT_FROM_PAIRED_DEVICES';
export const RE_REMOVE_EMAIL_FROM_BUNDLE = 'RE_REMOVE_EMAIL_FROM_BUNDLE';
export const RE_FTB_SET_API = 'RE_FTB_SET_API';
export const RE_FTB_GO_TO_AUTHORIZATION_PAGE = 'RE_FTB_GO_TO_AUTHORIZATION_PAGE';
export const RE_FTB_COPY_TOKEN_AND_REQUEST = 'RE_FTB_COPY_TOKEN_AND_REQUEST';
export const RE_FTB_TEST_TOKEN = 'RE_FTB_TEST_TOKEN';
export const RE_ADD_EMAIL_TO_DATABASE = 'RE_ADD_EMAIL_TO_DATABASE';
export const RE_SET_UP_GOOGLE_ACCOUNT = 'RE_SET_UP_GOOGLE_ACCOUNT';
export const RE_REPLACE_EMAIL = 'RE_REPLACE_EMAIL';

// Correct Phone Serial
export const CPS_UPDATE_BUNDLE = 'CPS_UPDATE_BUNDLE';
export const CPS_UPDATE_PLACEMENT = 'CPS_UPDATE_PLACEMENT';
export const CPS_CORRECT_LOCATION_TRACKER = 'CPS_CORRECT_LOCATION_TRACKER';
export const CPS_CORRECT_PHONE_SERIAL = 'CPS_CORRECT_PHONE_SERIAL';

// Wearable Serial Check
export const WSC_UPDATE_SERIAL = 'WSC_UPDATE_SERIAL';
export const WSC_UPDATE_WEARABLE = 'WSC_UPDATE_WEARABLE';
export const WSC_UPDATE_BUNDLE = 'WSC_UPDATE_BUNDLE';
export const WSC_UPDATE_PLACEMENT = 'WSC_UPDATE_PLACEMENT';
export const WSC_SERIALS_MATCH = 'WSC_SERIALS_MATCH';

// Remove Sensor
export const RS_COLLECT_DATA = 'RS_COLLECT_DATA';
export const RS_END_AND_REMOVE_SENSOR_PLACEMENT = 'RS_END_AND_REMOVE_SENSOR_PLACEMENT';
export const RS_SELECTED_POSITION_ID = 'RS_SELECTED_POSITION_ID';
export const RS_SELECTED_SERIAL = 'RS_SELECTED_SERIAL';
export const RS_SELECTED_BRAND = 'RS_SELECTED_BRAND';
export const RS_REMOVE_SENSOR = 'RS_REMOVE_SENSOR';
export const RS_UPDATE_BUNDLE_TO_DATABASE = 'RS_UPDATE_BUNDLE_TO_DATABASE';
export const RS_REMOVE_SENSOR_FROM_APP = 'RS_REMOVE_SENSOR_FROM_APP';

//MOVE SENSOR
export const MS_END_AND_REMOVE_SENSOR_PLACEMENT = 'MS_END_AND_REMOVE_SENSOR_PLACEMENT';
export const MS_SELECTED_POSITION_ID = 'MS_SELECTED_POSITION_ID';

// Add Sensor
export const AS_ADD_DEVICE_TO_APP = 'AS_ADD_DEVICE_TO_APP';
export const AS_UPDATE_BUNDLE_TO_DATABASE = 'AS_UPDATE_BUNDLE_TO_DATABASE';
export const AS_SET_UP_SENSOR = 'AS_SET_UP_SENSOR';
export const AS_DOWNLOAD_APP = 'AS_DOWNLOAD_APP';
export const AS_CREATE_ACCOUNT = 'AS_CREATE_ACCOUNT';
export const AS_ADD_INBOX_SENSOR = 'AS_ADD_INBOX_SENSOR';
export const AS_SET_UP_KESTREL_SENSOR = 'AS_SET_UP_KESTREL_SENSOR';
export const AS_DOWNLOAD_KESTREL_APP = 'AS_DOWNLOAD_KESTREL_APP';
export const AS_ADD_KESTREL_DEVICE_TO_APP = 'AS_ADD_KESTREL_DEVICE_TO_APP';
export const AS_DISABLE_KESTREL_AUTOCONNECT = 'AS_DISABLE_KESTREL_AUTOCONNECT';
export const AS_SET_LOG_KESTREL_INTERVAL = 'AS_SET_LOG_KESTREL_INTERVAL';

// Change House
export const CH_COLLECT_DATA = 'CH_COLLECT_DATA';
export const CH_REMOVE_PARTICIPANT_PLACEMENT = 'CH_REMOVE_PARTICIPANT_PLACEMENT';
export const CH_EXTRACT_LOCATIONS_COORDINATES = 'CH_EXTRACT_LOCATIONS_COORDINATES';
export const CH_ADD_LOCATION_TO_DATABASE = 'CH_ADD_LOCATION_TO_DATABASE';
export const CH_PARTICIPANT_PLACEMENT = 'CH_PARTICIPANT_PLACEMENT';

export const CH_REMOVE_SENSOR_PLACEMENT_BASE = 'CH_REMOVE_SENSOR_PLACEMENT_BASE';

export const getCHRSCheckBoxId = (positionID) => CH_REMOVE_SENSOR_PLACEMENT_BASE + '__' + positionID;

export const ASHP_ADD_PLACEMENT_BASE = 'ASHP_ADD_PLACEMENT_BASE';

export const getASHPCheckBoxId = (positionID) => ASHP_ADD_PLACEMENT_BASE + '__' + positionID;
export const getASHPLinkedClickedId = (positionID) => positionID + LINK_CLICKED;

export const BUNDLE_SET_UP_CHECKBOXES = [
  GA_SET_UP_GOOGLE_ACCOUNT,
  FTB_DOWNLOAD_APPLICATION,
  FTB_CREATE_NEW_ACCOUNT,
  FTB_SET_TIME_ZONE,
  FTB_SET_UP_DEVICE,
  AWP_GET_WEARABLE_SERIAL,
  AWP_LINK_WEARABLE_SERIAL,
  FTB_SET_API,
  FTB_GO_TO_AUTHORIZATION_PAGE,
  FTB_COPY_TOKEN_AND_REQUEST,
  FTB_TEST_TOKEN,
  GA_ADD_EMAIL_TO_DATABASE,
  APPD_LINK_PHONE_SERIAL,
  TA_SET_UP_TRACKER_APP,
  TA_DOWNLOAD_TACKER_APP,
  TA_LOCATION_PERMISSIONS,
  TA_GET_PHONE_SERIAL,
  TA_ACTIVATE_TRACKING,
  TA_TURN_ON_LOCATION,
  GAF_GROUP_APPS_IN_FOLDER,
  TB_TAG_BUNDLE,
  BD_ADD_BUNDLE_TO_DATABASE,
];

export const BUNDLE_SET_UP_GOVEE_CHECKBOXES = [
  SUG_SET_UP_SENSOR,
  SUG_DOWNLOAD_APP,
  SUG_CREATE_ACCOUNT,
  SUG_ADD_DEVICE_TO_APP,
  SUG_ADD_INBOX_SENSOR,
];

export const BUNDLE_SET_UP_KESTREL_CHECKBOXES = [
  SUK_SET_UP_SENSOR,
  SUK_DOWNLOAD_APP,
  SUK_ADD_DEVICE_TO_APP,
  SUK_DISABLE_AUTOCONNECT,
  SUK_SET_LOG_INTERVAL,
];

export const BUNDLE_DEPLOYMENT_CHECKBOXES = [
  APT_ADD_PARTICIPANT_TO_DATABASE,
  APPD_PHONE_PLACEMENT,
  AWP_WEARABLE_PLACEMENT,
  ELC_EXTRACT_LOCATIONS_COORDINATES,
  ALD_ADD_LOCATION_TO_DATABASE,
  APAR_PARTICIPANT_PLACEMENT,
  LTA_RESTART_TRACKING_APP,
  LTA_TURN_ON_LOCATION,
  LTA_TURN_ON_BLUETOOTH,
  IS_INSERT_SIM,
  ED_EXPLAIN_FITBIT,
  ED_EXPLAIN_DUTIES,
  GD_SHOW_PHONE_PIN,
  GD_GIVE_DEVICES,
  CC_COLLECT_DATA,
  PIF_AMINISTER_INTAKE_FORM,
  HIF_AMINISTER_INTAKE_FORM,
];

// Data Collection checkboxes
export const GD_CHECK_POSITION = 'GD_CHECK_POSITION';
export const GD_SYNC_DEVICES = 'GD_SYNC_DEVICES';
export const GD_SEND_EMAIL = 'GD_SEND_EMAIL';
export const GS_COLLECT_SENSOR_DATA = 'GD_COLLECT_SENSOR_DATA';

export const KS_COLLECT_SENSOR_DATA = 'KS_COLLECT_SENSOR_DATA';
export const KD_SYNC_DEVICES = 'KD_SYNC_DEVICES';
export const KD_SEND_EMAIL = 'KD_SEND_EMAIL';

export const MXHOBO_COLLECT_SENSOR_DATA = 'MXHOBO_COLLECT_SENSOR_DATA';
export const MXHOBO_SYNC_DEVICES = 'MXHOBO_SYNC_DEVICES';
export const MXHOBO_DOWNLOAD_DATA = 'MXHOBO_DOWNLOAD_DATA';
export const MXHOBO_SEND_EMAIL = 'MXHOBO_SEND_EMAIL';

export const WD_SYNC_WEARABLE_DATA = 'WD_SYNC_WEARABLE_DATA';
export const WD_CHECK_HEATRATE = 'WD_CHECK_HEATRATE';
export const LD_COLLECT_LOCATION_DATA = 'LD_COLLECT_LOCATION_DATA';
export const LD_EXPORT_DATA = 'LD_EXPORT_DATA';
export const LD_TURN_ON_BLUETOOTH = 'LD_TURN_ON_BLUETOOTH';
export const LD_CLOSE_APPLICATION = 'LD_CLOSE_APPLICATION';
export const LD_TURN_ON_LOCATION = 'LD_TURN_ON_LOCATION';
export const LD_RESET_TRACKING = 'LD_RESET_TRACKING';
export const LD_SCAN_FOR_DEVICES = 'LD_SCAN_FOR_DEVICES';

export const PS_ADMINISTER_PERCEPTUAL_SURVEY = 'PS_ADMINISTER_PERCEPTUAL_SURVEY';

export const DATA_COLLECT_CHECKBOXES = [
  SB_SYNC_BUNDLE,
  WD_SYNC_WEARABLE_DATA,
  WD_CHECK_HEATRATE,
  LD_COLLECT_LOCATION_DATA,
  LD_EXPORT_DATA,
  LD_TURN_ON_BLUETOOTH,
  LD_TURN_ON_LOCATION,
  LD_RESET_TRACKING,
  LD_SCAN_FOR_DEVICES,
  PS_ADMINISTER_PERCEPTUAL_SURVEY,
];

export const DATA_COLLECT_GOVEE_CHECKBOXES = [
  GS_COLLECT_SENSOR_DATA,
  GD_CHECK_POSITION,
  GD_SYNC_DEVICES,
  GD_SEND_EMAIL,
];

export const DATA_COLLECT_KESTREL_CHECKBOXES = [KS_COLLECT_SENSOR_DATA, KD_SYNC_DEVICES, KD_SEND_EMAIL];

export const DATA_COLLECT_HOBO_CHECKBOXES = [
  MXHOBO_COLLECT_SENSOR_DATA,
  MXHOBO_SYNC_DEVICES,
  MXHOBO_DOWNLOAD_DATA,
  MXHOBO_SEND_EMAIL,
];

export const DATA_COLLECT_DEVICE_CHECKBOXES = [
  GS_COLLECT_SENSOR_DATA,
  GD_CHECK_POSITION,
  GD_SYNC_DEVICES,
  GD_SEND_EMAIL,
  KS_COLLECT_SENSOR_DATA,
  KD_SYNC_DEVICES,
  KD_SEND_EMAIL,
  MXHOBO_COLLECT_SENSOR_DATA,
  MXHOBO_SYNC_DEVICES,
  MXHOBO_DOWNLOAD_DATA,
  MXHOBO_SEND_EMAIL,
];

// Speed Test
export const INTERNET_SPEED_TEST_LINK = 'https://www.google.com/search?q=speed+test';

// Wiki
export const WIKI_LINK = 'https://wiki.community-hats.net';

// Module Constants
export const MODULE_TEXT = 'text';
export const MODULE_ON_CLICK = 'onClick';
export const MODULE_TYPE = 'type';

// Airtable Objects
export const AT_OBJECT_EMAIL_ACCOUNT = 'AT_OBJECT_EMAIL_ACCOUNT';
export const AT_OBJECT_PHONE = 'AT_OBJECT_PHONE';
export const AT_OBJECT_PHONE_PLACEMENT = 'AT_OBJECT_PHONE_PLACEMENT';
export const AT_OBJECT_WEARABLE_PLACEMENT = 'AT_OBJECT_WEARABLE_PLACEMENT';
export const AT_OBJECT_HOUSE = 'AT_OBJECT_HOUSE';
export const AT_OBJECT_PARTICIPANT_PLACEMENT = 'AT_OBJECT_PARTICIPANT_PLACEMENT';
export const AT_OBJECT_PARTICIPANT = 'AT_OBJECT_PARTICIPANT';
export const AT_OBJECT_WEARABLE = 'AT_OBJECT_WEARABLE';
export const AT_OBJECT_BUNDLE = 'AT_OBJECT_BUNDLE';
export const AT_OBJECT_SENSOR = 'AT_OBJECT_SENSOR';
export const AT_OBJECT_SENSORS_HOUSE_PLACEMENT = 'AT_OBJECT_SENSORS_HOUSE_PLACEMENT';

// Action Items (the Airtable table is still called Issues; string values are persisted store keys, do not rename)
export const ACTION_ITEMS_OBJECT = 'ISSUES_OBJECT';
export const LAST_ACTION_ITEM_CHECK = 'last_issue_check';

// Array Airtable Objects
export const AT_SET_OF_OBJECTS = 'AT_SET_OF_OBJECTS';

// Received Files
export const AT_RECEIVED_SENSOR_FILES = 'AT_RECEIVED_SENSOR_FILES';

export const AT_OBJECT_BASE_STRUCTURE = {
  [libCon.STATUS]: ATO_EMPTY,
  [libCon.ID]: null,
  [libCon.FIELDS]: {},
};

export const AT_OBJECT_BASE_CONFIG = {
  [libCon.NECESSARY_IDS]: [],
  [libCon.OPTIONAL_IDS]: [],
  [libCon.COMPUTE_ON_UPLOAD]: {},
  [libCon.DERIVATE_IDS]: [],
  [libCon.SINGLE_DEPENDENCIES]: {},
  [libCon.SET_DEPENDENCIES]: {},
  [libCon.TABLE_CONFIG_KEY]: null,
  [libCon.SEARCH]: [],
  [libCon.IS_INSIDE_SET]: false,
};

// Configuration Rules
// Objects that have no multiplicityu are outside the set (Phone, Wearable, Participant etc..)
// Objects that have multiplicity are inside the set (Sensors, Sensors Placement)
// If an object is outside the set:
// * Single dependencies should only reference objects outside sets
// * Multiple dependencies should only reference objects iniside set and only ids are allowed.
//
// If an object is inside the set:
// * Single dependencies can reference both type of elements. If element is inside set, will only affect the elemen at the same position (sensor placement and sensor).
//   If the element is outside the set, it will affect all elements (House and sensors)
// * Multiple dependencies for objects inside set is not allowed.

export const AT_OBJECTS_CONFIGS = {
  [AT_OBJECT_SENSOR]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.NECESSARY_IDS]: [libCon.ATF_SERIAL],
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_SENSORS,
    [libCon.SEARCH]: [libCon.ATF_SERIAL],
    [libCon.IS_INSIDE_SET]: true,
  },
  [AT_OBJECT_SENSORS_HOUSE_PLACEMENT]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_SENSOR_HOUSE_PLACEMENT,
    [libCon.NECESSARY_IDS]: [
      libCon.ATF_LOCATION,
      libCon.ATF_SENSOR,
      libCon.ATF_LATITUDE,
      libCon.ATF_LONGITUDE,
      libCon.ATF_ACCURACY,
      libCon.ATF_POSITION,
    ],
    [libCon.OPTIONAL_IDS]: [
      libCon.ATF_SENSOR_POSITION_CHECKED_STATUS,
      libCon.ATF_OLD_POSITION,
      libCon.ATF_SENSOR_POSITION_CHECKED_DATE,
    ],
    [libCon.SINGLE_DEPENDENCIES]: {
      [AT_OBJECT_HOUSE]: {
        [libCon.ID]: libCon.ATF_LOCATION,
        [libCon.FIELDS]: {
          [libCon.ATF_NUMERIC_ID]: libCon.ATF_LOCATION_NUMERIC_ID,
        },
      },
      [AT_OBJECT_SENSOR]: {
        [libCon.ID]: libCon.ATF_SENSOR,
        [libCon.FIELDS]: {
          [libCon.ATF_SERIAL]: libCon.ATF_SENSOR_SERIAL,
        },
      },
    },
    [libCon.IS_INSIDE_SET]: true,
    [libCon.SEARCH]: [
      libCon.ATF_TAG_CODE,
      libCon.ATF_TAG_COLOR,
      libCon.ATF_POSITION,
      libCon.ATF_LOCATION_NUMERIC_ID,
      libCon.ATF_SENSOR_SERIAL,
    ],
  },
  [AT_OBJECT_WEARABLE]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.NECESSARY_IDS]: [libCon.ATF_SERIAL],
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_WEARABLES,
    [libCon.SEARCH]: [libCon.ATF_SERIAL],
  },
  [AT_OBJECT_PHONE]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.NECESSARY_IDS]: [libCon.ATF_SERIAL],
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_PHONES,
    [libCon.SEARCH]: [libCon.ATF_SERIAL],
  },
  [AT_OBJECT_PARTICIPANT]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.NECESSARY_IDS]: [
      libCon.ATF_NAME,
      libCon.ATF_LAST_NAME,
      libCon.ATF_SEWA_ID,
      libCon.ATF_PHONE_NUMBER,
      libCon.ATF_TRADE,
    ],
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_PARTICIPANTS,
    [libCon.SEARCH]: [libCon.ATF_SEWA_ID],
  },
  [AT_OBJECT_EMAIL_ACCOUNT]: {
    ...AT_OBJECT_BASE_CONFIG,
    // No Fitbit credential column appears here any more. They used to be
    // NECESSARY_IDS, which meant SyncATOButton pushed the token, the refresh
    // token and the request id to Airtable on every email sync, and refused to
    // enable until the browser was holding all of them. The OAuth callback on
    // the server writes those columns now, and the expiry and the request id
    // go with them: nothing in this app sets any of the five, so requiring one
    // would strand the set-up flow on an account that has never been linked.
    [libCon.NECESSARY_IDS]: [
      libCon.ATF_EMAIL,
      libCon.ATF_PASSWORD,
      libCon.ATF_DROPBOX_PASSWORD,
      libCon.ATF_GOVEE_PASSWORD,
    ],
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_EMAILS,
    [libCon.SEARCH]: [libCon.ATF_EMAIL],
    // Read for display by WearableStatusViewer and ExtraRequests, never
    // written: a DERIVATE_ID is carried locally and stripped before the push,
    // which is what keeps a stale pulled copy from overwriting the fresher
    // status the server just wrote.
    [libCon.DERIVATE_IDS]: [libCon.ATF_FITBIT_TOKEN_STATUS],
    [libCon.OPTIONAL_IDS]: [libCon.ATF_FITBIT_TOKEN_STATUS],
  },
  [AT_OBJECT_PHONE_PLACEMENT]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.NECESSARY_IDS]: [libCon.ATF_TAG_CODE, libCon.ATF_TAG_COLOR, libCon.ATF_PHONE, libCon.ATF_PARTICIPANT],
    [libCon.SINGLE_DEPENDENCIES]: {
      [AT_OBJECT_PHONE]: {
        [libCon.ID]: libCon.ATF_PHONE,
      },
      [AT_OBJECT_PARTICIPANT]: {
        [libCon.ID]: libCon.ATF_PARTICIPANT,
      },
    },
    [libCon.COMPUTE_ON_UPLOAD]: {
      [libCon.ATF_START_DATE]: () => nowInStudyLocation(true),
    },
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_PHONE_PLACEMENTS,
    [libCon.SEARCH]: [libCon.ATF_PHONE_SERIAL],
  },
  [AT_OBJECT_WEARABLE_PLACEMENT]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.NECESSARY_IDS]: [
      libCon.ATF_TAG_CODE,
      libCon.ATF_TAG_COLOR,
      libCon.ATF_WEARABLE,
      libCon.ATF_PARTICIPANT,
      libCon.ATF_ACCOUNT_EMAIL,
    ],
    [libCon.SINGLE_DEPENDENCIES]: {
      [AT_OBJECT_WEARABLE]: {
        [libCon.ID]: libCon.ATF_WEARABLE,
      },
      [AT_OBJECT_PARTICIPANT]: {
        [libCon.ID]: libCon.ATF_PARTICIPANT,
      },
      [AT_OBJECT_EMAIL_ACCOUNT]: {
        [libCon.ID]: libCon.ATF_ACCOUNT_EMAIL,
      },
    },
    [libCon.COMPUTE_ON_UPLOAD]: {
      [libCon.ATF_START_DATE]: () => nowInStudyLocation(true),
    },
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_WEARABLE_PLACEMENTS,
  },
  [AT_OBJECT_HOUSE]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.NECESSARY_IDS]: [
      libCon.ATF_LATITUDE,
      libCon.ATF_LONGITUDE,
      libCon.ATF_ACCURACY,
      libCon.ATF_PARTICIPANT,
      libCon.ATF_AREA,
      libCon.ATF_ADDRESS,
    ],
    [libCon.SINGLE_DEPENDENCIES]: {
      [AT_OBJECT_PARTICIPANT]: {
        [libCon.ID]: libCon.ATF_PARTICIPANT,
      },
    },
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_HOUSES,
  },
  [AT_OBJECT_PARTICIPANT_PLACEMENT]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.NECESSARY_IDS]: [libCon.ATF_PARTICIPANT, libCon.ATF_HOUSE],
    [libCon.SINGLE_DEPENDENCIES]: {
      [AT_OBJECT_PARTICIPANT]: {
        [libCon.ID]: libCon.ATF_PARTICIPANT,
      },
      [AT_OBJECT_HOUSE]: {
        [libCon.ID]: libCon.ATF_HOUSE,
      },
    },
    [libCon.COMPUTE_ON_UPLOAD]: {
      [libCon.ATF_START_DATE]: () => nowInStudyLocation(true),
    },
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_PARTICIPANTS_PLACEMENT,
  },
  [AT_OBJECT_BUNDLE]: {
    ...AT_OBJECT_BASE_CONFIG,
    [libCon.NECESSARY_IDS]: [
      libCon.ATF_PHONE_SERIAL,
      libCon.ATF_PHONE,
      libCon.ATF_ACCOUNT_EMAIL,
      libCon.ATF_WEARABLE,
      libCon.ATF_SENSORS,
      libCon.ATF_TAG_CODE,
      libCon.ATF_TAG_COLOR,
    ],
    [libCon.SINGLE_DEPENDENCIES]: {
      AT_OBJECT_PHONE: {
        [libCon.ID]: libCon.ATF_PHONE,
        [libCon.FIELDS]: {
          [libCon.ATF_SERIAL]: libCon.ATF_PHONE_SERIAL,
        },
      },
      AT_OBJECT_WEARABLE: {
        [libCon.ID]: libCon.ATF_WEARABLE,
      },
      AT_OBJECT_EMAIL_ACCOUNT: {
        [libCon.ID]: libCon.ATF_ACCOUNT_EMAIL,
      },
    },
    [libCon.SET_DEPENDENCIES]: {
      [AT_OBJECT_SENSOR]: {
        [libCon.ID]: libCon.ATF_SENSORS,
      },
    },
    [libCon.TABLE_CONFIG_KEY]: libCon.AT_TABLE_BUNDLES,
    [libCon.DERIVATE_IDS]: [libCon.ATF_PHONE_SERIAL],
    [libCon.SEARCH]: [libCon.ATF_PHONE_SERIAL],
  },
};

// Store Support Values
export const FITBIT_URL = 'fitbit_url';
export const FITBIT_API_OK = 'fitbit_api_ok';
export const FITBIT_TOKEN = 'fitbit_token';
export const FITBIT_REFRESH_TOKEN = 'fitbit_refresh_token';
export const FITBIT_REQUEST_ID = 'fitbit_request_id';

// Whether the Google Health token currently on the email record passed its test.
// Transient, so it is deliberately absent from the RESTART_BUNDLE_* carry overs.
export const GOOGLE_HEALTH_API_OK = 'google_health_api_ok';
export const LINK_CLICKED = '__LINK_CLICKED__';

// Recurent Surveys
export const RECURENT_SURVEY_CONFIGURATION_STATUS = 'RECURENT_SURVEY_CONFIGURATION_STATUS';
export const RS_CONNECTION_SENDING_ANSWERS_STATUS = 'RS_CONNECTION_SENDING_ANSWERS_STATUS';
export const PERCEPTUAL_SURVEY_FINAL_CONFIGURATION = 'PERCEPTUAL_SURVEY_FINAL_CONFIGURATION';
export const PERCEPTUAL_WOMENS_HEALTH_SURVEY_FINAL_CONFIGURATION =
  'PERCEPTUAL_WOMENS_HEALTH_SURVEY_FINAL_CONFIGURATION';
export const PERCEPTUAL_STREET_VENDOR_SURVEY_FINAL_CONFIGURATION =
  'PERCEPTUAL_STREET_VENDOR_SURVEY_FINAL_CONFIGURATION';
export const PERCEPTUAL_MENTAL_HEALTH_SURVEY_FINAL_CONFIGURATION =
  'PERCEPTUAL_MENTAL_HEALTH_SURVEY_FINAL_CONFIGURATION';

// Participant Intake Form
export const PIF_CONNECTION_SENDING_ANSWERS_STATUS = 'PIF_CONNECTION_SENDING_ANSWERS_STATUS';
export const PARTICIPANT_INTAKE_FORM_CONFIGURATION_STATUS = 'PARTICIPANT_INTAKE_FORM_CONFIGURATION_STATUS';
export const PARTICIPANT_INTAKE_FORM_ANSWERED_QUESTIONS = 'PARTICIPANT_INTAKE_FORM_ANSWERED_QUESTIONS';
export const PARTICIPANT_INTAKE_FORM_FINAL_CONFIGURATION = 'PARTICIPANT_INTAKE_FORM_FINAL_CONFIGURATION';
export const PARTICIPANT_STREET_VENDOR_INTAKE_FORM_FINAL_CONFIGURATION =
  'PARTICIPANT_STREET_VENDOR_INTAKE_FORM_FINAL_CONFIGURATION';

// House Intake Form
export const HIF_CONNECTION_SENDING_ANSWERS_STATUS = 'HIF_CONNECTION_SENDING_ANSWERS_STATUS';
export const HOUSE_INTAKE_FORM_CONFIGURATION_STATUS = 'HOUSE_INTAKE_FORM_CONFIGURATION_STATUS';
export const HOUSE_INTAKE_FORM_ANSWERED_QUESTIONS = 'HOUSE_INTAKE_FORM_ANSWERED_QUESTIONS';

// Collection Report
export const COLLECTION_REPORT_DURATION = 'collection_report_duration';
export const COLLECTION_REPORT_STATUS = 'collection_report_status';
export const COLLECTION_REPORT_NOTES = 'collection_report_notess';
export const COLLECTION_REPORT_LAST_UPLOAD = 'collection_last_upload';

// Logged in
export const LAST_LOG_IN = 'last_log_in';
// Signed proof that this client passed the password screen. Minted by
// checkPassword, expires after MAX_IDLE_MINUTES, i.e. exactly when isLoggedIn()
// starts saying false. Spent only on getApiToken, which trades it for the token
// below.
export const APP_TOKEN = 'app_token';
// The token the server mints, which the library sends straight to /api. Its own
// expiry is far longer than a session, so it is minted once at log in.
export const API_TOKEN = 'api_token';
export const API_TOKEN_EXPIRY = 'api_token_expiry';
export const SHOW_EMPTY_PAGE = 'show_empty_page';

// Orientations
export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';

// Forms
export const FORMS_LAST_CHECKED = 'forms_last_checked';
export const PENDING_FORM_QUESTIONS_OBJECT = 'pending_form_questions';

// Extra Request Constants
export const EXTRA_REQUEST_PENDING_ITEMS = 'extra_request_pending_items';
export const LAST_EXTRA_REQUEST_CHECK = 'last_extra_check';
export const EXTRA_REQUEST_STATUS_PENDING = 'Pending';
export const EXTRA_REQUEST_STATUS_COMPLETE = 'Complete';

// Reports
export const REPORT_DATE = 'REPORT_DATE';
export const REPORT = 'REPORT';

// Extra Requests
export const EXTRA_REQUEST_UPDATE_SENSOR_POSITION = 'EXTRA_REQUEST_UPDATE_SENSOR_LOCATION';
export const EXTRA_REQUEST_UPDATE_SENSOR_PHOTO = 'EXTRA_REQUEST_UPDATE_SENSOR_PHOTO';
export const EXTRA_REQUEST_UPDATE_MISSING_SEWA_ID = 'EXTRA_REQUEST_UPDATE_MISSING_SEWA_ID';
export const EXTRA_REQUEST_UPDATE_FITBIT_API_TOKEN = 'EXTRA_REQUEST_UPDATE_FITBIT_API_TOKEN';
export const EXTRA_REQUEST_UPDATE_GOOGLE_HEALTH_API_TOKEN = 'EXTRA_REQUEST_UPDATE_GOOGLE_HEALTH_API_TOKEN';

// Update sensor Position
export const EXTRA_REQUEST_UPDATE_SENSOR_POSITION_MISSING_IDS = 'extra_request_update_sensor_position_missing_ids';
export const EXTRA_REQUEST_UPDATE_SENSOR_POSITION_CHECK_BOX = 'EXTRA_REQUEST_UPDATE_SENSOR_POSITION_CHECK_BOX';
export const getUpdateSensorPositionCheckBoxId = (positionID) =>
  EXTRA_REQUEST_UPDATE_SENSOR_POSITION_CHECK_BOX + '__' + positionID;

// Update Sensor Photo
export const EXTRA_REQUEST_UPDATE_SENSOR_PHOTO_IDS = 'extra_request_update_sensor_photo_ids';
export const EXTRA_REQUEST_UPDATE_SENSOR_PHOTO_CHECK_BOX = 'EXTRA_REQUEST_UPDATE_SENSOR_PHOTO_CHECK_BOX';
export const getUpdateSensorPhotoCheckBoxId = (positionID) =>
  EXTRA_REQUEST_UPDATE_SENSOR_PHOTO_CHECK_BOX + '__' + positionID;

// Update Missing Sewa ID
export const EXTRA_REQUEST_UPDATE_MISSING_SEWA_ID_CHECK_BOX = 'EXTRA_REQUEST_UPDATE_MISSING_SEWA_ID_CHECK_BOX';
export const EXTRA_REQUEST_UPDATE_FITBIT_API_TOKEN_CHECK_BOX = 'EXTRA_REQUEST_UPDATE_FITBIT_API_TOKEN_CHECK_BOX';
export const EXTRA_REQUEST_UPDATE_GOOGLE_HEALTH_API_TOKEN_CHECK_BOX =
  'EXTRA_REQUEST_UPDATE_GOOGLE_HEALTH_API_TOKEN_CHECK_BOX';

export const EXTRA_REQUESTS_TO_CHECK = [
  EXTRA_REQUEST_UPDATE_SENSOR_PHOTO,
  EXTRA_REQUEST_UPDATE_SENSOR_POSITION,
  // EXTRA_REQUEST_UPDATE_MISSING_SEWA_ID,
  // EXTRA_REQUEST_UPDATE_FITBIT_API_TOKEN,
  EXTRA_REQUEST_UPDATE_GOOGLE_HEALTH_API_TOKEN,
];
